
export const getMethod = (query, axiosInstance) => axiosInstance.get(query);

export const patchMethod = ( query, axiosInstance, payload ) => axiosInstance.patch(query, payload);

export const deleteMethod = ( query, axiosInstance ) => axiosInstance.delete(query);

export const postMethod = ( query, payload, axiosInstance ) => axiosInstance.post(`${query}`, payload);
